/**
 * 将日期格式化成指定格式的字符串
 * @param date 要格式化的日期，不传时默认当前时间，也可以是一个时间戳
 * @param fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
 * @returns 返回格式化后的日期字符串
 */
import tinytime from 'tinytime'
const SIGN_REGEXP = /([yMdhsm])(\1*)/g
const DEFAULT_PATTERN = 'yyyy-MM-dd'
function padding(s, len) {
  len = len - (s + '').length
  for (let i = 0; i < len; i++) { s = '0' + s }
  return s
}

export default {
  formatDate: {
    format: function(date, pattern) {
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, function($0) {
        switch ($0.charAt(0)) {
          case 'y': return padding(date.getFullYear(), $0.length)
          case 'M': return padding(date.getMonth() + 1, $0.length)
          case 'd': return padding(date.getDate(), $0.length)
          case 'w': return date.getDay() + 1
          case 'h': return padding(date.getHours(), $0.length)
          case 'm': return padding(date.getMinutes(), $0.length)
          case 's': return padding(date.getSeconds(), $0.length)
        }
      })
    },
    parse: function(dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP)
      var matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length === matchs2.length) {
        var _date = new Date(1970, 0, 1)
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i])
          var sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y': _date.setFullYear(_int); break
            case 'M': _date.setMonth(_int - 1); break
            case 'd': _date.setDate(_int); break
            case 'h': _date.setHours(_int); break
            case 'm': _date.setMinutes(_int); break
            case 's': _date.setSeconds(_int); break
          }
        }
        return _date
      }
      return null
    }

  },

  format: function(date, fmt) {
    date = date === undefined ? new Date() : date
    date = typeof date === 'number' ? new Date(date) : date
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss'
    var obj =
      {
        'y': date.getFullYear(), // 年份，注意必须用getFullYear
        'M': date.getMonth() + 1, // 月份，注意是从0-11
        'd': date.getDate(), // 日期
        'q': Math.floor((date.getMonth() + 3) / 3), // 季度
        'w': date.getDay(), // 星期，注意是0-6
        'H': date.getHours(), // 24小时制
        'h': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
        'm': date.getMinutes(), // 分钟
        's': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
      }
    var week = ['天', '一', '二', '三', '四', '五', '六']
    for (var i in obj) {
      fmt = fmt.replace(new RegExp(i + '+', 'g'), function(m) {
        var val = obj[i] + ''
        if (i === 'w') return (m.length > 2 ? '星期' : '周') + week[val]
        for (var j = 0, len = val.length; j < m.length - len; j++) val = '0' + val
        return m.length === 1 ? val : val.substring(val.length - m.length)
      })
    }
    return fmt
  },

  timeFormat: function(time, format) {
    const dateTime = new Date(time)
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth() + 1
    const date = dateTime.getDate()
    const hour = dateTime.getHours()
    const minute = dateTime.getMinutes()
    const second = dateTime.getSeconds()
    if (format === 'yyyy-MM-dd HH:mm:ss') {
      return `${year}-${this.addZero(month)}-${this.addZero(date)} ${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`
    } else if (format === 'yyyy-MM-dd HH:mm') {
      return `${year}-${this.addZero(month)}-${this.addZero(date)} ${this.addZero(hour)}:${this.addZero(minute)}`
    } else if (format === 'yyyy-MM-dd') {
      return `${year}-${this.addZero(month)}-${this.addZero(date)}`
    }
  },
  addZero(v) {
    return v < 10 ? '0' + v : v
  },
  tinytime(date, format) {
    const template = tinytime(format, { padMonth: true, padDays: true })
    return template.render(date)
  },

  getLastDay() {
    var day = new Date()
    day.setDate(day.getDate() - 1)
    return this.format(day, 'yyyy-MM-dd')
  },

  formatChinese: function(timestamp, unit) {
    if (unit === 's') {
      timestamp = timestamp * 1000
    }
    const hours = parseInt((timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = parseInt((timestamp % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = ((timestamp % (1000 * 60)) / 1000).toFixed(2)
    if (hours === 0) {
      if (minutes === 0) {
        return seconds + '秒'
      } else {
        return minutes + '分钟' + seconds + '秒'
      }
    } else {
      return hours + '小时' + minutes + '分钟' + seconds + '秒'
    }
  }
}
